import classNames from 'classnames'
import React from 'react'
import styles from './StepBody.module.scss'

export interface StepBodyProps {
  className?: string
  children: React.ReactNode
}

const StepBody = ({ children, className }: StepBodyProps) => (
  <section className={classNames(styles.stepBody, className)}>{children}</section>
)

export default StepBody
